import CAROUSEL from './i18n/carousel.fr.json';
import COMMON from './i18n/common.fr.json';
import GOUVERNANCE from './i18n/gouvernance.fr.json';
import HEADER from './i18n/header.fr.json';
import SOCIAL from './i18n/social.fr.json';
import FOOTER from './i18n/footer.fr.json';
import PRESS_AREA from './i18n/press-area.fr.json';
import ERROR from './i18n/error.fr.json';
import HOME from './i18n/home.fr.json';
import ICON from './i18n/icon.fr.json';
import SHORTCUTS from './i18n/shortcuts.fr.json';
import MEDIA from './i18n/media.fr.json';
import MEDIA_THEMATIC from './i18n/media-thematic.fr.json';
import BRANCHES from './i18n/branches.fr.json';
import FINANCIAL from './i18n/financial.fr.json';
import CATEGORIES from './i18n/categories.fr.json';
import TERRITORIES from './i18n/territories.fr.json';
import THEMATICS from './i18n/thematics.fr.json';
import TYPES from './i18n/types.fr.json';
import AGENDA from './i18n/agenda.fr.json';
import FILTERS from './i18n/filters.fr.json';
import EXPERTISES from './i18n/expertises.fr.json';
import INNOVATIONS from './i18n/innovations.fr.json';
import CONTACTS from './i18n/contacts.fr.json';
import SEARCH from './i18n/search.fr.json';
import RGPD from './i18n/RGPD.fr.json';
import DATA_NOVA_MAP from './i18n/data-nova-map.fr.json';
import PAGINATION from './i18n/pagination.fr.json';
import PUBLICATION from './i18n/publication.fr.json';
import HUB_ACTUS from './i18n/hub-actualites.fr.json';

export {
  CAROUSEL,
  COMMON,
  GOUVERNANCE,
  HEADER,
  SOCIAL,
  FOOTER,
  PRESS_AREA,
  ERROR,
  HOME,
  ICON,
  SHORTCUTS,
  MEDIA,
  MEDIA_THEMATIC,
  BRANCHES,
  FINANCIAL,
  CATEGORIES,
  TERRITORIES,
  THEMATICS,
  TYPES,
  AGENDA,
  FILTERS,
  EXPERTISES,
  INNOVATIONS,
  CONTACTS,
  SEARCH,
  RGPD,
  DATA_NOVA_MAP,
  PAGINATION,
  PUBLICATION,
  HUB_ACTUS,
};

export default {
  ...CAROUSEL,
  ...COMMON,
  ...GOUVERNANCE,
  ...HEADER,
  ...SOCIAL,
  ...FOOTER,
  ...PRESS_AREA,
  ...ERROR,
  ...HOME,
  ...ICON,
  ...SHORTCUTS,
  ...MEDIA,
  ...MEDIA_THEMATIC,
  ...BRANCHES,
  ...FINANCIAL,
  ...CATEGORIES,
  ...TERRITORIES,
  ...THEMATICS,
  ...TYPES,
  ...AGENDA,
  ...FILTERS,
  ...EXPERTISES,
  ...INNOVATIONS,
  ...CONTACTS,
  ...SEARCH,
  ...RGPD,
  ...DATA_NOVA_MAP,
  ...PAGINATION,
  ...PUBLICATION,
  ...HUB_ACTUS,
};
